<template>
    <div id="line" ref="line"></div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    props: {
      lineDataProps: {
        type: Array,
        default: () => []
      },
      LineNameProps: {
        type: String,
        default: () => ''
      },
      legendProps: {
        type: Array,
        default: () => []
      },
      axisNameProps: {
        type: Object,
        default: function () {
          return {
            xName: '',
            yName: ''
          }
        }
      },
      // 页面是黑色底/白色底
      pageLight: {
        type: String,
        default: () => 'light'
      }
    },
    data() {
        return {
          myChart: null,
          labelData: [],
          dataList: []
        }
    },
    mounted() {
        this.myChart = echarts.init(this.$refs.line);
        this.init();
        window.addEventListener("resize", this.handleWindowResize);
    },
    watch: {
        lineDataProps: {
            handler(newValue) {
              // console.log(newValue,'newValue')
                if(newValue){
                    this.labelData = newValue[0];
                    if(Array.isArray(newValue[1])) {
                      this.dataList = [{
                          data: newValue[1],
                          type: 'line'
                        }]
                    } else {
                      this.dataList = newValue.slice(1)
                    }
                    this.init();
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        init() {
            this.$nextTick(() => {
              let _this = this;
              let option = {
                xAxis: {
                  type: 'category',
                  data: this.labelData,
                  name: this.axisNameProps.xName,
                  nameGap: 5,
                  nameLocation: 'end',
                  nameTextStyle: {
                    fontWeight: 'bolder',
                    fontSize: 10
                  }
                }, 
                legend: {
                  data: this.legendProps,
                  textStyle: {
                    color: this.pageLight==='light'?'#333':'#fff',
                    fontSize: 10
                  }
                },
                tooltip: {
                  trigger: 'axis',
                  formatter: function(params){
                    let str = params[0].axisValueLabel+'<br/>';
                    if(params.length>1) {
                      params.map(item => {
                        str+=item.marker+item.seriesName+': '+item.value+'&nbsp;'+(_this.axisNameProps.yName==='/分钟'?'(分钟)':(_this.axisNameProps.yName==='/次'?'(次)':(_this.axisNameProps.yName==='/数量'?'(个)':'')))+'<br/>'
                      })
                    }else {
                      str+=params[0].marker+'&nbsp;'+params[0].value+'&nbsp;' +(_this.axisNameProps.yName==='/分钟'?'(分钟)':(_this.axisNameProps.yName==='/次'?'(次)':(_this.axisNameProps.yName==='/数量'?'(个)':'')))
                    }
                    
                      return str
                  }
                },
                grid:{
                  top:"30px",
                  left:"50px",
                  right:"40px",
                  bottom:"30px"
                },
                yAxis: {
                  type: 'value',
                  name: this.axisNameProps.yName,
                  nameGap: 10,
                  nameLocation: 'end',
                  nameTextStyle: {
                    fontWeight: 'bolder',
                    fontSize: 10
                  },
                  axisLabel:{
                    formatter:(value) => {
                    if(value >= 10000){
                    value = (value / 10000) + 'W';
                    }
                    // if(value >= 1000){
                    // value = (value / 1000) + 'K';
                    // }
                    return value;
                    }
                  },
                },
                color: ['#FF6B00', '#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
                series: this.dataList
              };
              option && this.myChart.setOption(option);
            })
            
        }, 
        handleWindowResize() {
            if (!this.myChart) return;
            this.myChart.resize();
        },
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleWindowResize);
    },
}



</script>
<style scoped>
#line {
    width: 100%;
    height: 100%;
}
</style>